/* eslint-disable camelcase */
import React from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Modal, Fade, Backdrop, TextField, Button } from '@material-ui/core';

import PropTypes from 'prop-types';

import { Formik } from 'formik';
import * as yup from 'yup';

import { forgotPassword } from '../store/actions/auth';

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 18,
    margin: 0,
    color: '#1e3f9e',
    marginBottom: 25,
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    padding: '2rem',
    paddingTop: '1rem',
    minWidth: 550,
    maxWidth: '700px',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 4,
    boxShadow: theme.shadows[5],
    outline: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  buttonRow: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '2rem',
    width: '100%',
    justifyContent: 'space-around',
  },
  button: {
    width: '30%',
    padding: '0.6rem',
    color: 'white',
    backgroundColor: '#00d1b2',
    '&:hover': {
      backgroundColor: '#00bca0',
    },
  },
  form: {
    margin: '1rem',
    width: '100%',
    display: 'flex',
    flexFlow: 'row wrap',
  },
  field: {
    width: '100%',
  },
  error: {
    color: 'red',
  },
  nameFieldContainer: {
    width: '100%',
  },
}));

const ForgotPasswordModal = ({ open, setOpen }) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleClose = () => {
    setOpen(false);
  };

  const submitHandler = (values) => {
    dispatch(forgotPassword(values.email.toLowerCase()));
    setOpen(false);
  };

  const validationSchema = yup.object({
    email: yup.string("Enter User's Email").email('Enter a valid email').required('*Required'),
  });

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
    >
      <Fade in={open}>
        <div className={classes.paper}>
          <h2 className={classes.title}>Reset Password</h2>
          <Formik
            initialValues={{ email: '' }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              setTimeout(() => {
                submitHandler(values);
                setSubmitting(false);
              }, 400);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              /* and other goodies */
            }) => {
              return (
                <form className={classes.form} onSubmit={handleSubmit}>
                  <div className={classes.nameFieldContainer}>
                    <TextField
                      className={classes.field}
                      label="Email"
                      placeholder="Enter Email"
                      variant="outlined"
                      name="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                    />
                    <p className={classes.error}>{errors.email && touched.email && errors.email}</p>
                  </div>
                  <div className={classes.buttonRow}>
                    <Button
                      className={classes.button}
                      size="small"
                      variant="contained"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      Send Email
                    </Button>
                    <Button className={classes.button} size="small" variant="contained" onClick={handleClose}>
                      Cancel
                    </Button>
                  </div>
                </form>
              );
            }}
          </Formik>
        </div>
      </Fade>
    </Modal>
  );
};

ForgotPasswordModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
};

export default ForgotPasswordModal;
